import PhotoDocumentsRelabel from './PhotoDocumentsRelabel';

export default PhotoDocumentsRelabel;
